import { SVGProps } from "react";
const ShareSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      stroke="#7D8690"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15 9h2c1.105 0 2 .82 2 1.833v7.334C19 19.179 18.105 20 17 20H7c-1.105 0-2-.82-2-1.833v-7.334C5 9.821 5.895 9 7 9h2M12 15.001V2.996M15.002 5.997l-3-3-3.002 3"
    />
  </svg>
);
export default ShareSvg;
